import { render } from "./NewChatForm.vue?vue&type=template&id=62e59748&scoped=true"
import script from "./NewChatForm.vue?vue&type=script&lang=js"
export * from "./NewChatForm.vue?vue&type=script&lang=js"

import "./NewChatForm.vue?vue&type=style&index=0&id=62e59748&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Norbert\\webdev\\udemy-vue3\\chat\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62e59748"]])

export default __exports__